import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-current-fha',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['./current-fha.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CurrentFHAComponent extends ButtonStepComponent implements OnInit {
  title = "Do you currently have an FHA loan?";
  buttonList = [
    { text: "Don't Know", value: "no", imageName: 'dont-know', default: true},
    { text: 'Yes', value: 'yes', imageName: 'yes'},
    { text: 'No', value: 'no', imageName: 'no-x'},
  ];
  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('currentFHA', this.control);
  }

}
